export let delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
